import { render } from "./SalonWorkSlides.vue?vue&type=template&id=2ddc3202&scoped=true"
import script from "./SalonWorkSlides.vue?vue&type=script&lang=js"
export * from "./SalonWorkSlides.vue?vue&type=script&lang=js"

import "./SalonWorkSlides.vue?vue&type=style&index=0&id=2ddc3202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddc3202"]])

export default __exports__